// extracted by mini-css-extract-plugin
module.exports = {"link":"LinearCTAButton-module--link--zFrsI"};